import { createFileRoute } from '@tanstack/react-router';
import { QuotationWorkbench } from '@/features/quotations/QuotationWorkbench';

export const Route = createFileRoute('/_shell/quotations/$quotationId')({
  component: QuotationWorkbenchRoute,
});

function QuotationWorkbenchRoute() {
  const { quotationId } = Route.useParams();
  return <QuotationWorkbench key={quotationId} quotationId={quotationId} />;
}
